export var ColorModes;
(function (ColorModes) {
    ColorModes["DARK"] = "dark";
    ColorModes["LIGHT"] = "light";
    ColorModes["NONE"] = "none";
})(ColorModes || (ColorModes = {}));
